import { AlertCircle, Loader2 } from "lucide-react";

import { NoData } from "@/components/no-data";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useTranslation } from "react-i18next";

import { useNavigations } from "../api/get-navigations";

import { Navigation } from "./navigation";

type NavigationListProps = {
  congressId?: string;
};

function NavigationList(props: NavigationListProps) {
  const { t } = useTranslation();
  const { congressId } = props;
  const { data, isLoading, error, isSuccess } = useNavigations(congressId);

  if (isLoading) {
    return <Loader2 className="size-6 animate-spin text-primary" />;
  }

  if (error || !isSuccess) {
    return (
      <div className="max-w-96 space-y-4">
        <Alert variant="destructive">
          <AlertCircle className="size-4" />
          <AlertTitle>{t("common.errorTitle")}</AlertTitle>
          <AlertDescription>{error?.message}</AlertDescription>
        </Alert>
      </div>
    );
  }

  if (data.length < 1) {
    return <NoData description={t("navigationPage.noMenus")} />;
  }

  return (
    <div className="max-w-96 space-y-4">
      {data.map((navigation) => (
        <Navigation data={navigation} key={navigation.id} />
      ))}
    </div>
  );
}

export { NavigationList };
